  import truncate from "lodash/truncate";
  import atob from 'atob'
  export function truncateTool(description:any, limit:any) {
    if (typeof limit === "undefined") {
      limit = 50;
    }

    if (typeof description === "undefined") {
      return "";
    }

    let desc = description;
    desc = truncate(desc, { length: limit, separator: " " });

    return desc;
  }
    export function encodedBase64(obj:any) {
     var encodedBase64 = btoa(JSON.stringify(obj))
    return encodedBase64;
  }
    export function decodeBase64(obj:any) {
      var decodeBase64 =  JSON.parse(atob(obj))
    return decodeBase64;
  }

